import AccessTokenStore from './AccessTokenStore'

// The page's one store, shared by every consumer, React and non-React alike.
export default new AccessTokenStore()
